"use client";

import { Check, WarningCircle } from "@phosphor-icons/react/dist/ssr";
import type { ComponentPropsWithRef, ReactNode } from "react";
import { isObject } from "@/common/helpers/lang";
import { cn } from "@/services/styles/cn";
import styles from "./input-wrapper.module.css";

export type InputWrapperWrap = boolean | Omit<ComponentPropsWithRef<"div">, "children">;

export interface InputWrapperProps {
  children: ReactNode;
  wrap?: InputWrapperWrap;
}

export function InputWrapper({ wrap, children }: InputWrapperProps) {
  const { className, ...props } = isObject(wrap) ? wrap : {};

  return (
    <div className={cn(styles.inputWrapper, className)} {...props}>
      {children}
      <WarningCircle className={styles.warningIcon} />
      <Check className={styles.checkIcon} />
    </div>
  );
}
